export default function useFormattingPhoneNumber(phoneNumber: string): string {
  // 숫자와 *만 남기고 나머지 문자 제거
  phoneNumber = phoneNumber.replace(/[^0-9*]/g, "");

  const formatPatterns = [
    // 8자리 전화번호인 경우 (예: 1588-1588)
    { pattern: /^(\d{4})(\d{4})$/, format: "$1-$2" },
    // 지역번호가 2자리이고 나머지가 7자리인 경우 (예: 02-123-4567)
    { pattern: /^(\d{2})(\d{3})(\d{4})$/, format: "$1-$2-$3" },
    // 휴대폰 앞자리 혹은 지역번호가 3자리이고 나머지가 7자리인 경우 (예: 031-123-4567)
    { pattern: /^(\d{3})(\d{3})(\d{4})$/, format: "$1-$2-$3" },
    // 휴대폰 번호 혹은 지역번호가 3자리이고 나머지가 8자리인 경우 (예: 010-1234-5678)
    { pattern: /^(\d{3})(\d{4})(\d{4})$/, format: "$1-$2-$3" },
  ];

  for (const { pattern, format } of formatPatterns) {
    if (pattern.test(phoneNumber)) {
      phoneNumber = phoneNumber.replace(pattern, format);
      break; // 패턴이 매치되면 loop를 종료
    }
  }

  return phoneNumber;
}
